/* eslint-disable import/no-unresolved */

import React from 'react';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import highResDesktopImageWebp from './images/dip-hero.webp';
import highResMobileImageWebp from './images/dip-hero-mobile.webp';
// styles
import { HeroSectionStyled } from './styles';

export default () => {
  return (
    <HeroSectionStyled
      sectionId='physician-disability-insurance-hero'
      moduleName='hero-module'
      moduleVariation='A'
      productName='Physician Disability Insurance'
      headingText={
        <>Protect what you&#39;ve been working so <WidowBlock>hard for.</WidowBlock></>
      }
      descriptionText={
        <>We have industry leading options to help you replace some of your earned income if you ever become too sick or injured (even partially) to practice <WidowBlock>as usual.</WidowBlock></>
      }
      ctaPrimary={{
        linkUrl: '/find-a-financial-advisor/',
        buttonText: 'Get insurance',
        ariaLabel: 'Find a financial advisor here.',
        children: '',
      }}
      backgroundImageAriaLabel='two women in the medical field talking'
      backgroundImageDesktop={highResDesktopImageWebp.toString()}
      backgroundImageMobile={highResMobileImageWebp.toString()}
      backgroundImageDesktopLowRes='data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
      backgroundImageMobileLowRes='data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
      backgroundVariant='lightB'
      themeType='lightTheme'
    />
  );};
